import React from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps } from '@mui/material';
import { SealQuestionIcon  } from '@phosphor-icons/react/dist/ssr/SealQuestion';

interface Props {
  title: string,
  className?: string,
  text: string | JSX.Element,
  sx?: SxProps,
  showIcon?: boolean,
  icon?: React.JSX.Element,
}

export function V3InfoPanel({text, title, sx, showIcon, icon, className}: Props) {
  const qIcon = icon || <SealQuestionIcon  size={24} color="#19605D" weight="duotone" />;
  return <Box sx={{p: 3, backgroundColor: '#F0F7FA', borderRadius: '16px',  ...sx}} className={className}>
    {!!title && <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}>
      {showIcon !== false && qIcon}
      <Typography sx={{fontSize: 16, lineHeight: 1.5, fontWeight: 500}} className={'V3InfoPanel-title'}><b>{title}</b></Typography>
    </Box>}
    {typeof text === 'string' && <Typography sx={{fontSize: 16, lineHeight: 1.5, fontWeight: 500}} className={'V3InfoPanel-text'}>{text}</Typography>}
    {typeof text !== 'string' && <>{text}</>}
  </Box>
}
